import { css } from 'styled-components';

export const FileSelectWrapStyled = css`
    .modal-wrap-file-select {
        .ant-modal {
            top: 60px;
            height: 85vh;

            .ant-modal-content {
                height: 100%;

                 /* .ant-modal-body {
                   height: calc(100% - 108px);
                 } */
            }

            .ant-modal-body {
                margin-bottom: 30px;
            }

            .ant-modal-footer {
                display: flex;
                justify-content: space-between;
                
                .ant-row {
                    width: 100%;

                    /* .div__delete-button {
                         flex: 1 1 120px;
                        text-align: left;
                     } */

                    .div__usage-limit {
                        flex: 1 1 120px;
                        align-self: center;
                        padding-top: 4px;
                        font-weight: 300;
                        text-align: left;

                        @media only screen and (width <= 381px) {
                            display: none;
                            flex: 0;
                        }
                    }

                    .div__submit-cancel-buttons {
                        flex: 1 1 225px;

                        @media only screen and (width <= 576px) {
                            flex: 1 1 138px;

                            .btn--cancel {
                                display: none;
                            }
                        }
                    }

                }
            }
        }
    }

    .file-list-icon-list {
        .ant-list {
            .ant-list-item.file-list-item {
                margin-bottom: 0;

                .file-list-card > .ant-card-body {
                    max-height: 90px;
                    padding: 12px;

                    @media only screen and (width <= 767px) {
                        max-height: 70px;
                        padding: 10px;
                    }
                }
            }
        }
    }

`;
